module.exports = __webpack_public_path__ + "static/media/checkPurple.911331a8.svg";